import { render } from "./FeaturePage.vue?vue&type=template&id=2d656ea4&scoped=true&ts=true"
import script from "./FeaturePage.vue?vue&type=script&lang=ts"
export * from "./FeaturePage.vue?vue&type=script&lang=ts"

import "./FeaturePage.vue?vue&type=style&index=0&id=2d656ea4&scoped=true&lang=css"

import exportComponent from "C:\\Paii\\Projects\\TT Exclusive\\ttex_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d656ea4"]])

export default __exports__